import {DescriptionText, H1Text, TD, TH} from "../../../../design";
import React from "react";
import {AmountDivideByHundred} from "../../../../helper";
import {TAX_RATE_TYPES} from "../../../../appconstants";
import currencyFormatter from "../../../../utils/currencyformatter";

type Props = {
  invoices: Array,
  currency: Object,
  invoice: Object,
}

const InvoiceLineItem = (props: Props) => {
  const {invoices, currency, invoice} = props;

  const getTotalAmount = () => {
    return invoice && invoice.total;
  };

  const getDiscountOff = (value) => {
    let discountOff;
    const months = value && value.validiyInMonths;
    if (months && value.percentageOff) {
      discountOff = `${value.percentageOff}% off for ${months} months`;
    } else if (!months && value.percentageOff) {
      discountOff = `${value.percentageOff}% off ${value.validity}`;
    } else if (months && value.amountOff) {
      discountOff = `${value.amountOff / 100} off for ${months} months`;
    } else if (!months && value.amountOff) {
      discountOff = `${value.amountOff / 100} off ${value.validity}`;
    }
    return discountOff;
  };

  const getAmountOff = (value) => {
    let amountOff;
    if (value && value.percentageOff) {
      const amount = AmountDivideByHundred(invoice && invoice.amount * value.percentageOff);
      amountOff = currency && currencyFormatter((AmountDivideByHundred(amount)), currency.name);
    } else if (value && value.amountOff) {
      amountOff = currency && currencyFormatter(AmountDivideByHundred(value.amountOff), currency.name);
    }
    return amountOff;
  };

  return (
    <div className="row mt-4 px-3 px-lg-0">
      <div className="table-responsive invoice">
        <table className="table invoice-table text-left table-borderless">
          <thead style={{background:"#eeeeff", borderRadius: "3px !important"}}>
            <tr>
              <th colSpan="4" borderRadius="3px 0 0 3px"  className="border-0 w-50">
                <DescriptionText className="m-0">Description</DescriptionText>
              </th>
              <th className="text-center border-0">
                <DescriptionText className="m-0 text-center">Rate</DescriptionText>
              </th>
              <th className="text-center border-0">
                <DescriptionText className="m-0 text-center">Quantity</DescriptionText>
              </th>
              <th colSpan="2"  className="text-center border-0" borderRadius="0 3px 3px 0">
                <DescriptionText className="m-0 text-right">Total</DescriptionText>
              </th>
            </tr>
          </thead>
          <tbody>
          {
            invoices && invoices.map((value,index) => (
              <tr className="border-0 invoice-table-tr" key={index}>
                <td data-th="Name" colSpan="4" className="border-0">
                  <DescriptionText color="#1a1a1a" fontWeight="400" className="m-0">{value.name}</DescriptionText>
                </td>
                <td data-th="amount" className="text-center border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="m-0 text-center">
                    {value.amount && currency && currencyFormatter(AmountDivideByHundred(value.amount), currency.name)}
                  </DescriptionText>
                </td>
                <td data-th="quantity" className="text-center border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="m-0  text-center">{value.quantity}</DescriptionText>
                </td>
                <td data-th="total" colSpan="2"  className="text-center border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="m-0 text-right">
                    {value.quantity && value.amount && currency && currencyFormatter(AmountDivideByHundred(value.quantity * value.amount), currency.name)}
                  </DescriptionText>
                </td>
              </tr>
            ))
          }
          {
            invoice && invoice.coupon && invoice.coupon.name && (
              <tr className="border-0 invoice-table-tr">
                <td colSpan="4" className="border-0 w-50" />
                <td colSpan="2" className="text-left border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="ml-4 m-0 text-left">
                    {invoice.coupon.name} <br />
                    <span style={{ fontSize: '12px'}}>{getDiscountOff(invoice.coupon)}</span>
                  </DescriptionText>
                </td>
                <td data-th="total" colSpan="2"  className="text-center border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="m-0 text-right">
                  ({getAmountOff(invoice.coupon)})
                  </DescriptionText>
                </td>
              </tr>
            )
          }
          {invoice?.subscriptionDiscountAmount &&
              (
                  <tr>
                      <td colSpan="7" className="text-right border-0">
                          <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">subscription Discount &nbsp;&nbsp;&nbsp;&nbsp;
                              ({currency && currencyFormatter(AmountDivideByHundred(invoice.subscriptionDiscountAmount) , currency.name)})
                          </H1Text>
                      </td>
                  </tr>
              )
          }
          {
            invoice && invoice.taxAmount && invoice.taxAmount.map((value,index) => (
              <tr className="border-0 invoice-table-tr" key={index}>
                <td colSpan="4" className="border-0 w-50" />
                <td className="text-left border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="ml-4 m-0 text-left">
                  {value.taxRates.displayName} <br />
                    <span style={{ fontSize: '12px'}}>{value.taxRates.inclusive ? TAX_RATE_TYPES.INCLUSIVE : TAX_RATE_TYPES.EXCLUSIVE}</span>
                  </DescriptionText>
                </td>
                <td className="text-center border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="m-0  text-center">
                    {value.taxRates.percentage} %
                  </DescriptionText>
                </td>
                <td colSpan="2"  className="text-center border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="m-0 text-right">
                  {currency && currencyFormatter(AmountDivideByHundred(value.tax), currency.name)}
                  </DescriptionText>
                </td>
              </tr>
            ))
          }
              {
            invoice && invoice.shippingAmount > 0 && invoice.shippingAmount && (
              <tr className="border-0 invoice-table-tr">
                <td colSpan="4" className="border-0 w-50" />
                <td colSpan="2" className="text-left border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="ml-4 m-0 text-left">
                    Shipping Fee <br />
                  </DescriptionText>
                </td>
                <td data-th="total" colSpan="2"  className="text-center border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="m-0 text-right">
                  {currency && currencyFormatter(AmountDivideByHundred(invoice.shippingAmount) , currency.name)}
                  </DescriptionText>
                </td>
              </tr>
            )
          }
          {
            invoice && invoice.surchargeAmount > 0 && invoice.surchargeAmount && (
              <tr className="border-0 invoice-table-tr">
                <td colSpan="4" className="border-0 w-50" />
                <td colSpan="2" className="text-left border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="ml-4 m-0 text-left">
                    Surcharge Amount <br />
                  </DescriptionText>
                </td>
                <td data-th="total" colSpan="2"  className="text-center border-0">
                  <DescriptionText color="#000000" fontWeight="400" className="m-0 text-right">
                  {currency && currencyFormatter(AmountDivideByHundred(invoice.surchargeAmount) , currency.name)}
                  </DescriptionText>
                </td>
              </tr>
            )
          }
          </tbody>
          <tfoot className="text-right invoice-table-foot border-top">
          {invoice?.overdueFeeAmount &&
              (
                  <tr>
                      <td colSpan="7" className="text-right border-0">
                          <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Overdue Fee Amount (+)&nbsp;&nbsp;&nbsp;&nbsp;
                              {currency && currencyFormatter(AmountDivideByHundred(invoice.overdueFeeAmount) , currency.name)}
                          </H1Text>
                      </td>
                  </tr>
              )
          }
          {invoice?.invoiceType === "PARTIAL" && invoice?.lateFeeAmount &&
            (
              <tr>
                <td colSpan="7" className="text-right border-0">
                  <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Late Fee Amount (+)&nbsp;&nbsp;&nbsp;&nbsp;
                    {currency && currencyFormatter(AmountDivideByHundred(invoice.lateFeeAmount) , currency.name)}
                  </H1Text>
                </td>
              </tr>
            )
          }
          {invoice?.invoiceType === "PARTIAL" && invoice?.overdueInterestAmount &&
            (
              <tr>
                <td colSpan="7" className="text-right border-0">
                  <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Overdue Interest Amount (+)&nbsp;&nbsp;&nbsp;&nbsp;
                    {currency && currencyFormatter(AmountDivideByHundred(invoice.overdueInterestAmount) , currency.name)}
                  </H1Text>
                </td>
              </tr>
            )
          }
          <tr>
            <td colSpan="7" className="text-right border-0">
              <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Total Amount&nbsp;&nbsp;&nbsp;&nbsp;
                {currency && currencyFormatter(AmountDivideByHundred(getTotalAmount()), currency.name)}
              </H1Text>
            </td>
          </tr>
          {invoice?.invoiceType === "PARTIAL" && invoice?.paidAmount &&
            (
              <tr>
                <td colSpan="7" className="text-right border-0">
                  <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Paid Amount (-)&nbsp;&nbsp;&nbsp;&nbsp;
                    {currency && currencyFormatter(AmountDivideByHundred(invoice.paidAmount) , currency.name)}
                  </H1Text>
                </td>
              </tr>
            )
          }
          {invoice?.invoiceType === "PARTIAL" && invoice?.paidAmount &&
            (
              <tr>
                <td colSpan="7" className="text-right border-0">
                  <H1Text fontWeight="600" fontSize="14px" className="m-0 text-right">Remaining Amount&nbsp;&nbsp;&nbsp;&nbsp;
                    {currency && currencyFormatter(AmountDivideByHundred(getTotalAmount() - invoice.paidAmount) , currency.name)}
                  </H1Text>
                </td>
              </tr>
            )
          }
          </tfoot>
        </table>
      </div>
    </div>
  )
}

export default InvoiceLineItem
